import { render, staticRenderFns } from "./AreaDateTimeDisplay.vue?vue&type=template&id=3d856a66&scoped=true&v-if=this.timeZone"
import script from "./AreaDateTimeDisplay.vue?vue&type=script&lang=ts"
export * from "./AreaDateTimeDisplay.vue?vue&type=script&lang=ts"
import style0 from "./AreaDateTimeDisplay.vue?vue&type=style&index=0&id=3d856a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d856a66",
  null
  
)

export default component.exports